import SVGBag from 'thememadamesumuksvg/bag.svg?inline';
import SVGBox from 'thememadamesumuksvg/box.svg?inline';
import SVGCart from 'thememadamesumuksvg/cart.svg?inline';
import SVGCash from 'thememadamesumuksvg/cash.svg?inline';
import SVGCategoryCurries from 'thememadamesumuksvg/category-curries.svg?inline';
import SVGCategoryExtras from 'thememadamesumuksvg/category-extras.svg?inline';
import SVGClock from 'thememadamesumuksvg/clock.svg?inline';
import SVGClose from 'thememadamesumuksvg/close.svg?inline';
import SVGCreditCard from 'thememadamesumuksvg/credit-card.svg?inline';
import SVGDatatrans from 'thememadamesumuksvg/datatrans.svg?inline';
import SVGDate from 'thememadamesumuksvg/date.svg?inline';
import SVGDelivery from 'thememadamesumuksvg/delivery.svg?inline';
import SVGDownload from 'thememadamesumuksvg/download.svg?inline';
import SVGDumplingSticks from 'thememadamesumuksvg/dumpling-sticks.svg?inline';
import SVGDumpling from 'thememadamesumuksvg/dumpling.svg?inline';
import SVGDumplingsBasket from 'thememadamesumuksvg/dumplings-basket.svg?inline';
import SVGDuplicate from 'thememadamesumuksvg/duplicate.svg?inline';
import SVGEdit from 'thememadamesumuksvg/edit.svg?inline';
import SVGEnvelope from 'thememadamesumuksvg/envelope.svg?inline';
import SVGFacebookNoBorder from 'thememadamesumuksvg/facebook-no-border.svg?inline';
import SVGFacebook from 'thememadamesumuksvg/facebook.svg?inline';
import SVGFilter from 'thememadamesumuksvg/filter.svg?inline';
import SVGGeoLocation from 'thememadamesumuksvg/geo-location.svg?inline';
import SVGHeartFull from 'thememadamesumuksvg/heart-full.svg?inline';
import SVGHeart from 'thememadamesumuksvg/heart.svg?inline';
import SVGInfo from 'thememadamesumuksvg/info.svg?inline';
import SVGInsta from 'thememadamesumuksvg/insta.svg?inline';
import SVGInstagram from 'thememadamesumuksvg/instagram.svg?inline';
import SVGLabelLeaf from 'thememadamesumuksvg/label-leaf.svg?inline';
import SVGLinkedin from 'thememadamesumuksvg/linkedin.svg?inline';
import SVGLoaderStack from 'thememadamesumuksvg/loader-stack.svg?inline';
import SVGLocation from 'thememadamesumuksvg/location.svg?inline';
import SVGLogoMadamesum from 'thememadamesumuksvg/logo-madamesum.svg?inline';
import SVGLogoMadamesumuk from 'thememadamesumuksvg/logo-madamesumuk.svg?inline';
import SVGMap from 'thememadamesumuksvg/map.svg?inline';
import SVGMenu from 'thememadamesumuksvg/menu.svg?inline';
import SVGMidCircleChevronDown from 'thememadamesumuksvg/mid-circle-chevron-down.svg?inline';
import SVGMidCircleChevronLeft from 'thememadamesumuksvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'thememadamesumuksvg/mid-circle-chevron-right.svg?inline';
import SVGMidCircleChevronUp from 'thememadamesumuksvg/mid-circle-chevron-up.svg?inline';
import SVGMinus from 'thememadamesumuksvg/minus.svg?inline';
import SVGPaymentAmex from 'thememadamesumuksvg/payment-amex.svg?inline';
import SVGPaymentApplepay from 'thememadamesumuksvg/payment-applepay.svg?inline';
import SVGPaymentCoinify from 'thememadamesumuksvg/payment-coinify.svg?inline';
import SVGPaymentGooglepay from 'thememadamesumuksvg/payment-googlepay.svg?inline';
import SVGPaymentIcons from 'thememadamesumuksvg/payment-icons.svg?inline';
import SVGPaymentInvoice from 'thememadamesumuksvg/payment-invoice.svg?inline';
import SVGPaymentKlarna from 'thememadamesumuksvg/payment-klarna.svg?inline';
import SVGPaymentMastercard from 'thememadamesumuksvg/payment-mastercard.svg?inline';
import SVGPaymentPaypal from 'thememadamesumuksvg/payment-paypal.svg?inline';
import SVGPaymentTwint from 'thememadamesumuksvg/payment-twint.svg?inline';
import SVGPaymentVisa from 'thememadamesumuksvg/payment-visa.svg?inline';
import SVGPhone from 'thememadamesumuksvg/phone.svg?inline';
import SVGPinterest from 'thememadamesumuksvg/pinterest.svg?inline';
import SVGPlanzer from 'thememadamesumuksvg/planzer.svg?inline';
import SVGPlay from 'thememadamesumuksvg/play.svg?inline';
import SVGPlus from 'thememadamesumuksvg/plus.svg?inline';
import SVGPreparationBamboo from 'thememadamesumuksvg/preparation-bamboo.svg?inline';
import SVGPreparationPot from 'thememadamesumuksvg/preparation-pot.svg?inline';
import SVGPreparationSteamer from 'thememadamesumuksvg/preparation-steamer.svg?inline';
import SVGScanIllustrationPhone from 'thememadamesumuksvg/scan-illustration-phone.svg?inline';
import SVGSearch from 'thememadamesumuksvg/search.svg?inline';
import SVGSmallCheckmark from 'thememadamesumuksvg/small-checkmark.svg?inline';
import SVGSnowflake from 'thememadamesumuksvg/snowflake.svg?inline';
import SVGStarHalf from 'thememadamesumuksvg/star-half.svg?inline';
import SVGStar from 'thememadamesumuksvg/star.svg?inline';
import SVGSticks from 'thememadamesumuksvg/sticks.svg?inline';
import SVGTakeaway from 'thememadamesumuksvg/takeaway.svg?inline';
import SVGTiktok from 'thememadamesumuksvg/tiktok.svg?inline';
import SVGTrash from 'thememadamesumuksvg/trash.svg?inline';
import SVGTwitter from 'thememadamesumuksvg/twitter.svg?inline';
import SVGUser from 'thememadamesumuksvg/user.svg?inline';
import SVGUsers from 'thememadamesumuksvg/users.svg?inline';
import SVGVdepot from 'thememadamesumuksvg/vdepot.svg?inline';
import SVGWhatsapp from 'thememadamesumuksvg/whatsapp.svg?inline';
import SVGYoutube from 'thememadamesumuksvg/youtube.svg?inline';

export default {
	SVGBag,
	SVGBox,
	SVGCart,
	SVGCash,
	SVGCategoryCurries,
	SVGCategoryExtras,
	SVGClock,
	SVGClose,
	SVGCreditCard,
	SVGDatatrans,
	SVGDate,
	SVGDelivery,
	SVGDownload,
	SVGDumplingSticks,
	SVGDumpling,
	SVGDumplingsBasket,
	SVGDuplicate,
	SVGEdit,
	SVGEnvelope,
	SVGFacebookNoBorder,
	SVGFacebook,
	SVGFilter,
	SVGGeoLocation,
	SVGHeartFull,
	SVGHeart,
	SVGInfo,
	SVGInsta,
	SVGInstagram,
	SVGLabelLeaf,
	SVGLinkedin,
	SVGLoaderStack,
	SVGLocation,
	SVGLogoMadamesum,
	SVGLogoMadamesumuk,
	SVGMap,
	SVGMenu,
	SVGMidCircleChevronDown,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMidCircleChevronUp,
	SVGMinus,
	SVGPaymentAmex,
	SVGPaymentApplepay,
	SVGPaymentCoinify,
	SVGPaymentGooglepay,
	SVGPaymentIcons,
	SVGPaymentInvoice,
	SVGPaymentKlarna,
	SVGPaymentMastercard,
	SVGPaymentPaypal,
	SVGPaymentTwint,
	SVGPaymentVisa,
	SVGPhone,
	SVGPinterest,
	SVGPlanzer,
	SVGPlay,
	SVGPlus,
	SVGPreparationBamboo,
	SVGPreparationPot,
	SVGPreparationSteamer,
	SVGScanIllustrationPhone,
	SVGSearch,
	SVGSmallCheckmark,
	SVGSnowflake,
	SVGStarHalf,
	SVGStar,
	SVGSticks,
	SVGTakeaway,
	SVGTiktok,
	SVGTrash,
	SVGTwitter,
	SVGUser,
	SVGUsers,
	SVGVdepot,
	SVGWhatsapp,
	SVGYoutube
}